import styled from "styled-components";

export const StyledUploadFile = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const UploadFileButton = styled.div`
    color: #8181A5;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 100%;
    padding: 10px;
    cursor: pointer;
    border: 1px solid transparent;
    border-image: url("/button/button-border.svg") 1 stretch;
`;

export const UploadFileList = styled.div<{isPreviewPhoto: boolean}>`
    display: flex;
    flex-direction: ${({isPreviewPhoto}) => isPreviewPhoto ? "row" : "column"};
    gap: ${({isPreviewPhoto}) => isPreviewPhoto ? "20px" : "10px"};
    .row {
        display: flex;
        gap: 10px;
        width: 100%;
        .fileName {
            width: 100%;
            border-radius: 4px;
            border: 1px solid #E1E4EA;
            padding: 0px 10px;
            height: 37px;
            display: flex;
            gap: 10px;
            align-items: center;
            .onlytitle {
                color: #8181A5;
                font-size: 12px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                text-align: center;
                width: 100%;
            }
            .box {
                width: 25px;
                height: 25px;
                background: rgba(0, 0, 0, 0.20);
            }
            span {
                color: #282A42;
                font-size: 14px;
                font-style: normal;
                font-weight: 300;
                line-height: 100%;
            }
        }
        .buttonFile {
            width: 41px;
            padding: 0;
        }
    }
`;

export const WrapperLocalImage = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    position: relative;
`

export const LocalImage = styled.img`
    width: 100px;
    height: 60px;
    border-radius: 4px;
    object-fit: cover;
`

export const DeleteLocalImage = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 50px;
    overflow: hidden;
    display: flex;
    align-items: center;
    background-color: #8181A5;
    justify-content: center;
    cursor: pointer;
`

export const LocalImageBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        position: absolute;
        width: 20px;
        height: 20px;
        display: none;
        fill: white;
    }
    &:hover {
        cursor: pointer;
        &::before {
            content: '';
            width: 100px;
            height: 60px;
            position: absolute;
            left: 0;
            top: 0;
            background: #00000057;
            border-radius: 4px;
        }
        svg {
            display: block;
        }
    }
`